import YudlButton from "../../components/Button";
import Line from "../../components/Icons/Line";
import { ROUTES } from "../../constants";
import "./style.css"

const PortfolioIntro = () => {
  return (
    <div className="portfolio-show-case-content">
      <p className="portfolio-title text-theme text-center">We believe your idea can make the change you hope</p>
      <p className="portfolio-title text-theme text-center">
        to affect if you target the <strong>right customers.</strong>
      </p>
      <p className="mt-4 portfolio-title text-theme text-center">
        We help <strong>identify customers’ demands</strong>
      </p>
      <p className="portfolio-title text-theme text-center">for your product</p>
      <div className="d-flex justify-content-center my-5">
        <YudlButton buttonRole="link" link={ROUTES.ABOUTUS} children="Learn more about us" />
      </div>
      <div className="d-flex justify-content-center my-5">
        <Line />
      </div>
      <p className="text-center text-theme">See All our works</p>
    </div>
  );
};

export default PortfolioIntro;
